import { render, staticRenderFns } from "./todayPlayerPointSML4.vue?vue&type=template&id=ff8e1a56&"
import script from "./todayPlayerPointSML4.vue?vue&type=script&lang=js&"
export * from "./todayPlayerPointSML4.vue?vue&type=script&lang=js&"
import style0 from "./todayPlayerPointSML4.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports